//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { convertTime } from '../../components/helpers.js'

export default {
  name: 'ReportStateChanges',
  props: {
    report: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      columns: [
        {
          name: 'time',
          label: 'Дата/время изменения',
          align: 'left',
          field: 'time',
          format: this.formatDataFromUnixTime,
          classes: 'class-bordered',
          width: 150
        },
        {
          name: 'name',
          label: 'Статус',
          align: 'left',
          field: 'name',
          classes: 'class-bordered',
          width: 210
        },
        {
          name: 'user',
          label: 'Пользователь',
          align: 'left',
          field: 'user',
          classes: 'class-bordered',
          width: 300
        },
        {
          name: 'reason',
          label: 'Комментарий',
          align: 'left',
          field: 'reason',
          classes: 'class-bordered',
          width: 500
        }
      ],
      pagination: {
        page: 1,
        rowsPerPage: 0
      },

      userIds: {}
    }
  },
  methods: {
    formatDataFromUnixTime: function (unixTime) {
      if (unixTime != null) {
        return convertTime(unixTime)
      } else {
        return 'Нет данных'
      }
    },
    formatUser: function (value) {
      if (value.fio) {
        return value.fio
      } else {
        if (value.user == 'root') {
          return 'Дельта 2.0'
        } else {
          return value.user
        }
      }
    }
  }
}

